import './Footer.css';

export default function Footer() {
  return (
    <footer>
      <div className="container">
        <span>
          Request features <a href="https://github.com/stellaw1/bldr/issues">here</a> ·
          Show support <a href="https://github.com/sponsors/stellaw1">here</a>
        </span>

        <span className="copyright">
          &copy; 2025 Stella Wang
        </span>
      </div>
    </footer>
  );
}
